import { Dayjs } from "dayjs"

export const EAsnStatus = {
  MISSING: "missing",
  MISSING_DATE: "missingDate",
  EXPIRED: "expired",
  EXPIRES_SOON: "expiresSoon",
  UNOBTAINABLE: "unobtainable",
  VALID: "valid",
} as const

export type EAsnStatusType = (typeof EAsnStatus)[keyof typeof EAsnStatus]

export interface IInstallCode {
  id: number
  msn: string
  createdAt: Dayjs
  updatedAt: Dayjs
  meterType?: string
  mpxn?: string
  asnDate?: Dayjs
  asnOutcome?: string
  comment?: string
  deviceId?: string
  installCode?: string
  lastDateChecked?: Dayjs
  mapId?: string
  mapName?: string
  requestedDate?: Dayjs

  getAsnStatus(): EAsnStatusType
  getAsnMessage(): string | null
}

// Install code table details plus extra relationships
export interface IInstallCodeExtra extends IInstallCode {
  manufacturer?: string
  deviceModel?: string
  gbcsVersion?: string
  smetsVersion?: string
  firmwareVersion?: string
}
